import { ApiError } from "@/api/errors";

/** Serializer-level validation errors (not about one field) arrive under this key. */
const NON_FIELD = "non_field_errors";

/** Field-level error lookup for a mutation error (server validation is authoritative). */
export function fieldErrors(error: unknown) {
  return (name: string): string | undefined => (error instanceof ApiError ? error.fieldError(name) : undefined);
}

/**
 * First error for a field or anything nested in it. Nested errors arrive flattened with dotted keys,
 * e.g. `points.0.value` for the first contact point's value.
 */
export function nestedFieldError(error: unknown, prefix: string): string | undefined {
  if (!(error instanceof ApiError)) return undefined;
  const key = Object.keys(error.fields).find((k) => (k === prefix || k.startsWith(`${prefix}.`)) && error.fields[k].length > 0);
  return key ? error.fields[key][0] : undefined;
}

/**
 * Error to show above a form. Field errors are shown next to their fields, so a validation error (400)
 * or a conflict (409, e.g. a duplicate name) with only field errors returns null; `non_field_errors` are
 * about the whole form, so they are always returned.
 */
export function formError(error: unknown): unknown {
  if (!error) return null;
  if (error instanceof ApiError && (error.code === "validation_error" || error.status === 400 || error.status === 409)) {
    const nonField = error.fields[NON_FIELD]?.[0];
    if (nonField) return new ApiError(error.status, error.code, nonField);
    if (Object.keys(error.fields).length > 0) return null;
  }
  return error;
}
